export enum VoucherType {
    PERCENTAGE = 'percentage',
    FIXED_AMOUNT = 'fixed_amount',
}
